<template>
	<div>
		<Bj :bjData="bjData" />
		<div class="contactBox main">
			<div class="wayTxt">联系方式</div>
			<div class="company">湖南米啦科技有限公司</div>
			<div class="mediate minbox">
				<div class="item mediate">
					<img src="../../assets/pc/contact/mail.png" alt="" />
					<span>guohao@hskgoo.com</span>
				</div>
				<div class="mediate">
					<img src="../../assets/pc/contact/address.png" alt="" />
					<span>湖南省长沙市岳麓区天顶街道环湖路 1177号方茂苑（二期）12、13、15栋1916室</span>
				</div>
			</div>
		</div>
		<myBaiduMap class="myBaiduMap" />
	</div>
</template>

<script>
import myBaiduMap from '@/components/pc/myBaiduMap.vue'
import Bj from '@/components/pc/bj'
export default {
	components: {
		Bj,
		myBaiduMap,
	},
	data() {
		return {
			bjData: {
				imgUrl: 'https://qn.juquedu.com/contact.png',
				title: '联系我们',
				minTitle: '欢迎联络和合作',
			},
		}
	},
}
</script>

<style lang="scss" scoped>
.contactBox {
	.wayTxt {
		font-size: 36px;
		margin-top: 70px;
	}
	.company {
		font-size: 24px;
		margin-top: 24px;
	}
	.minbox {
		font-size: 18px;
		margin-top: 33px;
		margin-bottom: 86px;
		.item {
			margin-right: 320px;
		}
		img {
			width: 42px;
			height: 42px;
			margin-right: 20px;
		}
	}
}
.myBaiduMap {
	margin-bottom: 100px;
}
</style>
